__turbopack_context__.v({
  "Cont": "LargeVideo-module-sass-module__7_DrSW__Cont",
  "Image": "LargeVideo-module-sass-module__7_DrSW__Image",
  "LargeVideo": "LargeVideo-module-sass-module__7_DrSW__LargeVideo",
  "Main": "LargeVideo-module-sass-module__7_DrSW__Main",
});
